import { useCallback, useEffect, useRef, useState } from "react";
import "../../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap4.css";
import "../../../node_modules/semantic-ui-css/components/icon.min.css";
import { TabulatorFull as Tabulator } from "tabulator-tables";
import React from "react";
import { getDataSetNamePBI, useHttpClient } from "../modules/services/Bundle";
import { IGatewaysModel } from "../modules/services/core/_models";
import { RequestMethod } from "../modules/services/core/_enums";
import ReactApexChart from 'react-apexcharts';
import { useLocation } from "react-router-dom";
import moment from "moment";
import { useAuth } from "../modules/auth";
import Select from "react-select";




const MenuAddAlertGateway: React.FC = () => {
  const location = useLocation();
  const httpClient = useHttpClient();
  const [selectedOrganization, setSelectedOrganization] = useState<string>("");
  const [gatewayFilter, setGatewayFilter] = useState<string>("");
  const [selectedGateway, setSelectedGateway] = useState<string | null>(null);
  const dataSetNamePBI = getDataSetNamePBI();
  const [dataUsers, setDataUsers] = useState<User[]>([]);
  const [alertLevel, setAlertLevel] = useState<string>("");
  const [responsibleUser, setResponsibleUser] = useState<string>("");
  const [requestingUser, setRequestingUser] = useState<string>("");
  const [ticketNumber, setTicketNumber] = useState<string>("");
  const [subject, setSubject] = useState<string>("");
  const [idemail, setIdemail] = useState<number | null>(null);
  const [selectedIdPlace, setSelectedIdPlace] = useState<number | null>(null);
  const [chamadosGateway, setChamadosGateway] = useState<any[]>([]);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [detalhesGateway, setDetalhesGateway] = useState<IGatewaysModel[]>([]);
  const [filteredGateways, setFilteredGateways] = useState<IGatewaysModel[]>([]);
  const [isLoading, setIsLoading] = useState(true); // Adicionar estado de loading


  const { auth } = useAuth()
  const user = auth?.User
  const emailUsuario = user?.Email
  const [availableOrganizations, setAvailableOrganizations] = useState<
    Organization[]
  >([]);
  const [initialOrganizations, setInitialOrganizations] = useState<string[]>(
    []
  );
  const [selectedOrganizations, setSelectedOrganizations] = useState<string[]>(
    []
  );
  const [userId, setUserId] = useState<string>("");

  interface Organization {
    OrganizationId: string;
    OrganizationName: string;
  }


  const fetchUserId = async () => {
    if (!emailUsuario) {
      console.log("Email do usuário não disponível");
      return;
    }

    try {
      const url = `${backendUrl}/api/User/ByEmail/${encodeURIComponent(
        emailUsuario
      )}`;
      console.log("Fazendo requisição para:", url);

      const response = await fetch(url);
      console.log("Status da resposta:", response.status);

      if (response.ok) {
        const userId = await response.json();
        console.log("Dados do usuário:", userId);
        setUserId(userId.toString()); // Convertendo para string pois o ID vem como número
        return userId.toString(); // Retornando como string para manter consistência
      } else {
        const errorText = await response.text();
        console.error(
          "Erro ao buscar ID do usuário. Status:",
          response.status,
          "Texto:",
          errorText
        );
      }
    } catch (error) {
      console.error("Erro ao buscar ID do usuário:", error);
    }
  };

  // Nova função para buscar organizações do usuário
  const fetchUserOrganizations = async (id: string) => {
    if (!id) {
      console.log("ID do usuário não disponível"); // Debug quando não há ID
      return;
    }

    try {
      const url = `${backendUrl}/api/UserOrganization/OrgByUser?userId=${id}`;
      console.log("Fazendo requisição para:", url); // Debug da URL

      const response = await fetch(url);
      console.log("Status da resposta:", response.status); // Debug do status da resposta

      if (response.ok) {
        const data = await response.json();
        console.log("Organizações recebidas:", data); // Debug das organizações

        if (Array.isArray(data) && data.length > 0) {
          setAvailableOrganizations(data);
          const orgNames = data.map(
            (org: Organization) => org.OrganizationName
          );
          console.log("Nomes das organizações:", orgNames); // Debug dos nomes das organizações
          setInitialOrganizations(orgNames);
        } else {
          console.log(
            "Nenhuma organização encontrada ou formato inválido:",
            data
          );
        }
      } else {
        const errorText = await response.text();
        console.error(
          "Erro ao buscar organizações. Status:",
          response.status,
          "Texto:",
          errorText
        );
      }
    } catch (error) {
      console.error("Erro ao buscar organizações:", error);
    }
  };

  useEffect(() => {
    const initializeData = async () => {
      if (emailUsuario) {
        const id = await fetchUserId();
        if (id) {
          await fetchUserOrganizations(id);
        }
      }
      await obterDetalhesGateway(initialOrganizations);
      await obterUsuarios();
    };

    initializeData();
  }, [emailUsuario]);


  const aplicarFiltroOrganizacoes = async (Organizations: string[]) => {
    if (Organizations.length > 0) {
      await obterDetalhesGateway(Organizations);
      console.log(Organizations); // Filtra os dados por organização
    } else {
      await obterDetalhesGateway(); // Carrega todos os dados
    }
  };


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const gatewayParam = searchParams.get("gateway");

    if (gatewayParam) {
      setSelectedGateway(gatewayParam);
      handleGatewaySelection(gatewayParam);
    }
  }, [location]);

  const obterDetalhesGateway = async (orgs?: string[]) => {
    try {
      setIsLoading(true);
      console.log("Iniciando obterMapaGateway");

      const endpoint = orgs?.length ? '/Gerenciamento/PowerBI/ObterGatewaysByOrg' : '/Gerenciamento/PowerBI/ObterGateways';

      const queryParams = new URLSearchParams();
      if (dataSetNamePBI) {
        queryParams.append('datasetName', dataSetNamePBI);
      }

      if (orgs?.length) {
        orgs.forEach(org => queryParams.append('organization', org));
      }

      const response = await httpClient.request({
        method: RequestMethod.GET,
        endpoint: `${endpoint}?${queryParams.toString()}`,
      });

      if (response.success && response.payload) {
        setDetalhesGateway(response.payload);
        setFilteredGateways(response.payload); // Atualiza ambos os estados
      }
    } catch (error) {
      console.error("Erro ao obter lista de gateways:", error);
    } finally {
      setIsLoading(false);
    }
  };



  const handleSubmit = async () => {
    // Validação de campos obrigatórios
    if (!selectedGateway || !subject || !alertLevel || !responsibleUser) {
      alert('Por favor, preencha todos os campos obrigatórios: Gateway, Assunto, Nível do Alerta e Usuário Responsável');
      return;
    }

    // Obtém os detalhes do gateway selecionado
    const selectedGatewayDetails = detalhesGateway.find(a => a.Gateway.trim() === selectedGateway.trim());

    if (!selectedGatewayDetails) {
      alert('Gateway não encontrado. Por favor, selecione um gateway válido.');
      return;
    }

    // Verifica se o usuário responsável foi selecionado corretamente
    const responsibleUserObj = dataUsers.find(user => user.Id === parseInt(responsibleUser));
    if (!responsibleUserObj) {
      alert('Usuário responsável inválido. Por favor, selecione novamente.');
      return;
    }

    const matchedOrganization = availableOrganizations.find(
      (org) => org.OrganizationName === selectedGatewayDetails.Organizacao
    );
    const idOrganization = matchedOrganization ? matchedOrganization.OrganizationId : 0;

    // Prepara os dados para envio
    const alertData = {
      Chamado: ticketNumber,
      Assunto: subject,
      Dados: {
        Local: selectedGatewayDetails.Local,
        Status: selectedGatewayDetails.Status,
        Gateway: selectedGatewayDetails.Gateway,
        Latitude: selectedGatewayDetails.Latitude || 0,
        IdGateway: selectedGatewayDetails.IdGateway,
        Longitude: selectedGatewayDetails.Longitude || 0,
        SystemName: "TGAGRO",
        Corporation: "Raizen",
        Temperature: selectedGatewayDetails.Temperature || 0,
        Nivelalerta: alertLevel.toString(),
        Organization: selectedGatewayDetails.Organizacao,
        IdAlertLevels: parseInt(alertLevel),
        TempoDecorrido: selectedGatewayDetails.TempoDecorrido || 0,
        MinutosDeAlerta: 0,
        TempoDeCarencia: "0",
        UltimaAtualizacao: selectedGatewayDetails.UltimaAtualizacao,
        LastDeviceReadCount: 0,
      },
      IdUsuarioOwner: idemail,
      IdUsuarioResponsible: parseInt(responsibleUser),
      IdOrganization: idOrganization,
      IdGateway: selectedGatewayDetails.IdGateway,
      IdPlace: selectedGatewayDetails.IdPlace,
      IdAlertLevel: parseInt(alertLevel)
    };

    console.log('Dados sendo enviados:', alertData);

    try {
      const response = await fetch(`${backendUrl}/api/PlaceWorkFlow`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth?.Token}` // Adicione isso se sua API requer autenticação
        },
        body: JSON.stringify(alertData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erro ao criar alerta');
      }

      const responseData = await response.json();
      alert('Alerta criado com sucesso!');
      console.log('Resposta do servidor:', responseData);

      // Limpa os campos após sucesso (opcional)
      setTicketNumber('');
      setSubject('');
      setAlertLevel('');
      setResponsibleUser('');

    } catch (error) {
      console.error('Erro ao criar alerta:', error);
      alert(`Erro ao criar alerta: ${error}`);
    }
  };

  interface User {
    Id: number;
    Email: string;
    Name: string;
    // Adicione outras propriedades se necessário
  };

  useEffect(() => {
    const obterIdEmail = async () => {
      if (emailUsuario) {
        try {
          const encodedEmail = encodeURIComponent(emailUsuario);
          const response = await fetch(
            `${backendUrl}/api/User/ByEmail/${encodedEmail}`,
            {
              method: "GET",
              headers: {
                accept: "*/*",
              },
            }
          );
          const responseJson = await response.json();
          console.log("responseJson:", responseJson);

          // Verifica se a resposta é um número (ID)
          if (typeof responseJson === 'number') {
            setIdemail(responseJson);
          } else if (responseJson && responseJson.id) {
            setIdemail(responseJson.id);
          } else {
            console.error("ID do usuário não encontrado na resposta:", responseJson);
          }
        } catch (error) {
          console.error("Erro ao buscar ID do usuário:", error);
        }
      }
    };

    obterIdEmail();
  }, [emailUsuario]);

  const obterChamadosGateway = async (gateway: string) => {
    try {
      const response = await fetch(`${backendUrl}/api/PlaceWorkFlow/ByGatewayName/${gateway}`, {
        method: 'GET',
        headers: {
          'Accept': '*/*',
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log(data);
        // Filtra os dados com base no selectedGateway
        const filteredData = data.filter((item: any) => {
          try {
            const parsedData = JSON.parse(item.Dados);
            return parsedData.Gateway === gateway;
          } catch (e) {
            console.error('Erro ao parsear JSON:', e);
            return false;
          }
        });
        setChamadosGateway(filteredData);
      } else {
        console.error('Erro ao buscar dados:', response.statusText);
      }
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
  };


  const handleGatewaySelection = useCallback((gateway: string) => {
    const selectedGatewayDetails = detalhesGateway.find(g => g.Gateway.trim() === gateway.trim());
    if (selectedGatewayDetails) {
      setSelectedGateway(gateway);
      setSelectedIdPlace(selectedGatewayDetails.IdPlace); // Armazenar o IdPlace
      obterChamadosGateway(gateway); // Chamar a função para buscar os chamados do gateway
    }
  }, [detalhesGateway]);

  const handleGatewayFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    const gateway = event.target.value;
    setGatewayFilter(gateway);
    filterGateways(gateway);
  };

  const filterGateways = (gateway: string) => {
    let filtered = detalhesGateway;
    if (gateway) {
      filtered = filtered.filter(g => g['Gateway'].includes(gateway));
    }
    setFilteredGateways(filtered);
  };

  const obterUsuarios = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/User`, {
        method: 'GET',
        headers: {
          'Accept': '*/*',
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log(data);
        setDataUsers(data);
      } else {
        console.error('Erro ao buscar dados:', response.statusText);
      }
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
  };

  useEffect(() => {
    obterDetalhesGateway();
    obterUsuarios();
  }, []);

  return (
    <div className="d-flex" style={{ height: "55vh" }}>
      <div style={{ display: "flex", flexDirection: "column", width: "20%", padding: "10px", marginBottom: "10px" }}>
        {/* Filtro de Organização */}
        <div style={{ flex: 1, maxWidth: "300px", marginBottom: "10px" }}>
          <Select
            isMulti
            options={(() => {
              const opts = availableOrganizations.map((org) => ({
                label: org.OrganizationName,
                value: org.OrganizationName,
              }));
              console.log("Opções do Select:", opts); // Debug das opções do Select
              return opts;
            })()}
            onChange={(selectedOptions: any) => {
              console.log("Opções selecionadas:", selectedOptions); // Debug das seleções
              const selectedOrgs = selectedOptions
                ? selectedOptions.map((opt: any) => opt.value)
                : [];
              setSelectedOrganizations(selectedOrgs);
              aplicarFiltroOrganizacoes(selectedOrgs);
            }}
            placeholder="Filtrar por Organização"
            isClearable
            classNamePrefix="react-select"
          />
        </div>

        {/* Título e Filtro de Ativo */}
        <div style={{ marginBottom: "10px", textAlign: "center" }}>
          <h4 style={{ marginBottom: "10px" }}>Lista de Gateways</h4>
          <input
            type="text"
            placeholder="Digite o codigo do gateway"
            value={gatewayFilter}
            onChange={handleGatewayFilter}
            style={{
              width: "100%",
              padding: "5px",
              borderRadius: "5px",
              border: "1px solid var(--bs-border-color)",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              backgroundColor: "var(--bs-body-bg)",
              color: "var(--bs-body-color)",
            }}
          />
        </div>
        {/* Lista de Gateways */}
        <div
          className="sidebar"
          style={{
            borderRight: "1px solid #ccc",
            borderBottom: "1px solid #ccc",
            padding: "10px",
            overflowY: "auto",
            minHeight: "500px",
            maxHeight: "100%",
            borderRadius: "5px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <ul style={{ listStyleType: "none", padding: 0 }}>
            {filteredGateways && filteredGateways.length > 0 ? (
              filteredGateways.map((gateway: IGatewaysModel) => (
                <li
                  key={gateway.Gateway}
                  style={{
                    padding: "10px",
                    marginBottom: "8px",
                    border: "1px solid var(--bs-border-color)",
                    borderRadius: "5px",
                    backgroundColor: selectedGateway?.trim() === gateway.Gateway.trim() ? "var(--bs-secondary-bg)" : "var(--bs-body-bg)",
                    color: "var(--bs-body-color)",
                    fontWeight: selectedGateway?.trim() === gateway.Gateway.trim() ? "bold" : "normal",
                    cursor: "pointer",
                    transition: "background-color 0.3s ease, color 0.3s ease",
                    textAlign: "center",
                  }}
                  onClick={() => handleGatewaySelection(gateway.Gateway)}
                >
                  {gateway.Gateway}
                </li>
              ))
            ) : (
              <li style={{
                padding: "20px",
                textAlign: "center",
                color: "#666",
                fontStyle: "italic"
              }}>
                {detalhesGateway.length === 0 ? "Carregando gateways..." : "Nenhum gateway encontrado"}
              </li>
            )}
          </ul>
        </div>
      </div>


      <div style={{ width: "35%", padding: "10px" }}>
        <h1 style={{ textAlign: "center", marginBottom: "0px", borderBottom: "0px solid var(--bs-border-color)" }}>Inclusão de alertas Gateways</h1>
        {selectedGateway ? (
          <div
            className="detalhamento-gateway"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "5px",
              padding: "20px",
              border: "2px solid var(--bs-border-color)",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
            }}
          >
            {detalhesGateway
              .filter((gateway) => gateway.Gateway.trim() === selectedGateway.trim())
              .slice(0, 1) // Garante apenas 1 item
              .map((gateway, index) => (<React.Fragment key={index}>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Local:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{gateway.Local}</div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Gateway:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{gateway.Gateway}</div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Usuário requisitante:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{emailUsuario}</div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>
                  Nro do chamado:
                </div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>
                  <input
                    type="text"
                    value={ticketNumber}
                    onChange={(e) => setTicketNumber(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "5px",
                      borderRadius: "5px",
                      fontWeight: "bold",
                      border: "1px solid var(--bs-border-color)",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "var(--bs-body-bg)",
                      color: "var(--bs-body-color)",
                    }}
                    placeholder="Digite o número do chamado"
                  />
                </div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>
                  Assunto:
                </div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>
                  <input
                    type="text"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "5px",
                      fontWeight: "bold",
                      borderRadius: "5px",
                      border: "1px solid var(--bs-border-color)",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "var(--bs-body-bg)",
                      color: "var(--bs-body-color)",
                    }}
                    placeholder="Digite o assunto"
                  />
                </div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Nivel do alerta:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>
                  <select
                    value={alertLevel}
                    onChange={(e) => setAlertLevel(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "5px",
                      borderRadius: "5px",
                      border: "1px solid var(--bs-border-color)",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "var(--bs-body-bg)",
                      color: "var(--bs-body-color)",
                    }}
                  >
                    <option value="">Escolher</option>
                    <option value="1">Atenção</option>
                    <option value="2">Baixo</option>
                    <option value="3">Médio</option>
                    <option value="4">Alto</option>
                    <option value="5">Crítico</option>
                  </select>
                </div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>
                  Usuário responsável:
                </div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>
                  <select
                    value={responsibleUser}
                    onChange={(e) => setResponsibleUser(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "5px",
                      borderRadius: "5px",
                      border: "1px solid var(--bs-border-color)",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "var(--bs-body-bg)",
                      color: "var(--bs-body-color)",
                    }}
                  >
                    <option value="">Escolher</option>
                    {dataUsers
                      .sort((a, b) => a.Name.localeCompare(b.Name)) // Ordena os usuários em ordem alfabética
                      .map((user: User) => (
                        <option key={user.Id} value={user.Id}>
                          {user.Name}
                        </option>
                      ))}
                  </select>
                </div>
                <div style={{ marginTop: '20px' }}>
                  <button className="ui primary button" onClick={handleSubmit}>Criar Alerta</button>
                </div>
              </React.Fragment>
              ))}
          </div>
        ) : (
          <p>Selecione um gateway</p>
        )}
      </div>
    </div>
  );
};

export default MenuAddAlertGateway;